export default [
  {
    slug: 'slug',
    name: 'الرئيسية',
    iconPack: 'feather',
    icon: 'HomeIcon',
    pathName: 'courseHome',
  },
  {
    slug: 'slug',
    name: 'المحاضرات',
    iconPack: 'feather',
    icon: 'LayersIcon',
    pathName: 'courseLectures',
  },
  {
    slug: 'slug',
    name: 'الاختبارات',
    iconPack: 'feather',
    icon: 'HelpCircleIcon',
    pathName: 'courseQuizzes',
  },
  {
    slug: 'slug',
    name: 'الواجبات',
    iconPack: 'feather',
    icon: 'FileTextIcon',
    pathName: 'courseAssignments',
  },
  {
    header: "النقاشات",
    icon: "MessageSquareIcon",
    items: [
      {
        pathName: 'courseDiscussions',
        query: {privacy: 'all-students'},
        name: "المادة",
        icon: 'CircleIcon',
        slug: 'discussions'
      },
      {
        pathName: 'courseDiscussions',
        query: {privacy: 'my-students'},
        name: "مجموعاتي",
        icon: 'CircleIcon',
        slug: 'discussions'
      },
    ]
  },
  {
    slug: 'slug',
    name: 'الطلبة',
    iconPack: 'feather',
    icon: 'UsersIcon',
    pathName: 'courseStudents',
    role: 'teacher'
  },
  {
    slug: 'slug',
    name: 'بنك الأسئلة',
    iconPack: 'feather',
    icon: 'ArchiveIcon',
    pathName: 'courseQuestionBanks',
    role: 'student'
  },
  {
    slug: 'slug',
    name: 'دفتر الدرجات',
    iconPack: 'feather',
    icon: 'ClipboardIcon',
    pathName: 'courseGradebook',
    role: 'teacher'
  },
]
